import adminAxios from "@/shared/api/adminAxiosInstance";

// Залы
export const getGameRooms = (params = { page: 0, size: 100 }) => {
  return adminAxios.get("/admin/game-rooms", { params });
};

// выходной / рабочий день (один)
export const getDayOff = (date) => {
    return adminAxios.get('/admin/calendar/day-off', {
        params: { date }
    })
  };

// Календарь (диапазон)
export const getDayOffRange = (startDate, endDate) => {
  return adminAxios.get("/admin/calendar/day-off-range", {
    params: { startDate, endDate },
  });
};

// Шаблоны слотов
export const getTimeSlotTemplates = () => {
  return adminAxios.get("/admin/time-slot-templates");
};

// шаблоны слотов
export const getSlotTemplates = () =>
    adminAxios.get('/admin/time-slot-templates');

// Занятые слоты (по неделе)
export function getOccupiedSlotsOfDay({ startDate, endDate, roomId }) {
  return adminAxios.get("/admin/slots/occupied", {
    params: { startDate, endDate, roomId },
  });
}

export function getOccupiedSlots (startDate, endDate) {
  return adminAxios.get("/admin/slots/occupied", {
    params: {startDate, endDate}
  })
}